<template lang="html">
  <div class="">
    <div class="detailsContent">
      <div class="oneDetail">

        <div class="value">
            <span class="voteValue">{{ formattedNumber(vote.averageVotePerStartup)}}&nbsp;/&nbsp;5</span>
            <span class="voteCriteria">{{ $t("Average Score")}}</span>

        </div>
        <div class="progress-bar">
          <div class="progress-bar-fill" :style="{ width: computedProgress(vote.averageVotePerStartup) + '%' }"></div>
        </div>
      </div>

    </div>
  </div>

</template>


<script>
export default {
  name : "AverageVote",
  data() {
    return {
      detailsToogled : true,
    }
  },
  methods:{

    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(number);
    },
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },
      getaverageVote(){
        return 0;
      }

  },
  computed: {
 },
  props: ["vote"]
}
</script>

<style media="screen" scoped>


 .detailsContent{

  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
}
.oneDetail{

}
.value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
}

.progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}


.oneDetail.small .value{
  display:flex;
  justify-content:  space-between;
  gap:10px;

}
.oneDetail.small .voteValue{
  font-weight: 100;
  font-size:20px;
  color:#0A2071;
  line-height: 25px;
}
.oneDetail.small .voteCriteria{
  color:#0A2071;
  font-size:14px;
  font-weight: 400;
}

.oneDetail.small .progress-bar {
  margin-top:10px;
  width: calc(100% );
  height: 4px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}
.progress-bar-fill-2 {
  height: 100%;
  background-color: #125AA4; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

.detail.small{
  margin-top:10px;
  display: flex;
  flex-direction: column;
  gap:10px;
}

.reverseTheSvg svg{
  transform:rotate(-180deg);
}

.voteCriteria small{
  font-weight: 200;
  font-size:12px;
}


</style>
